import { getPublicKey } from "./fusionAuthKey";
import { arrayBufferToBase64, pemToArrayBuffer } from "./helpers";

export async function encryptPayload(payload) {
  const publicKeyPem = getPublicKey();

  const rsaKey = await crypto.subtle.importKey(
    "spki",
    pemToArrayBuffer(publicKeyPem),
    {
      name: "RSA-OAEP",
      hash: "SHA-256"
    },
    false,
    ["encrypt"]
  );

  const aesKey = await crypto.subtle.generateKey(
    { name: "AES-GCM", length: 256 },
    true,
    ["encrypt"]
  );

  const rawAesKey = await crypto.subtle.exportKey("raw", aesKey);

  const encryptedKey = await crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    rsaKey,
    rawAesKey
  );

  const data = {
    ...payload,
    timestamp: payload.timestamp ?? Math.floor(Date.now() / 1000)
  };

  const iv = crypto.getRandomValues(new Uint8Array(12));

  const encryptedPayload = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    aesKey,
    new TextEncoder().encode(JSON.stringify(data))
  );

  const combined = new Uint8Array(iv.length + encryptedPayload.byteLength);
  combined.set(iv, 0);
  combined.set(new Uint8Array(encryptedPayload), iv.length);

  return {
    key: arrayBufferToBase64(encryptedKey),
    data: arrayBufferToBase64(combined.buffer)
  };
}